import { useState, useMemo } from 'react'
import Timeline from '../components/Timeline'
import MemoryItem from '../components/MemoryItem'
import SubHeading from '../components/subHeading/SubHeading'
import NewsletterCTA from '../components/NewsletterCTA'
import memoriesData from '../mocks/memories.json'

import './memories.scss'

const renderFormattedText = (text) => (
  text.split(/(\[.*?\]\(.*?\)|\*\*\*.*?\*\*\*|\*\*.*?\*\*|\*.*?\*)/g).map((part, index) => {
    const linkMatch = part.match(/^\[(.*?)\]\((.*?)\)$/)

    if (linkMatch) {
      const [, label, href] = linkMatch

      return (
        <a key={`${part}-${index}`} href={href} target='_blank' rel='noreferrer'>
          {label}
        </a>
      )
    }

    if (part.startsWith('***') && part.endsWith('***')) {
      return <strong key={`${part}-${index}`}><em>{part.slice(3, -3)}</em></strong>
    }

    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={`${part}-${index}`}>{part.slice(2, -2)}</strong>
    }

    if (part.startsWith('*') && part.endsWith('*')) {
      return <em key={`${part}-${index}`}>{part.slice(1, -1)}</em>
    }

    return part
  })
)

const Memories = () => {
  const years = useMemo(() => 
    memoriesData.memories.map(m => m.year).sort((a, b) => a - b),
    []
  )

  const [selectedYear, setSelectedYear] = useState(years[0])

  const currentYearData = useMemo(() => 
    memoriesData.memories.find(m => m.year === selectedYear),
    [selectedYear]
  )

  return (
    <section className='memories-page section__padding'>
      {/* Hero Section */}
      <div className='memories-page__hero'>
        <p className='memories-page__eyebrow'>Nuestro recorrido</p>
        <div className='memories-page__heading'>
          <SubHeading title='Memorias' color={true} />
        </div>
        <div className='memories-page__divider' aria-hidden='true'></div>
        <p className='memories-page__intro'>
          Aquí se recogen los momentos más relevantes de nuestra trayectoria: 
          los logros alcanzados, los eventos realizados y las actividades que 
          nos definen como comunidad.
        </p>
        <p className='memories-page__intro-secondary'>
          Navega por años para explorar nuestro camino.
        </p>
      </div>

      {/* Timeline Section */}
      <div className='memories-page__timeline-section'>
        <Timeline 
          years={years}
          selectedYear={selectedYear}
          onYearChange={setSelectedYear}
        />
      </div>

      {/* Memory Items Grid */}
      <div className='memories-page__content'>
        <div className='memories-page__year-label'>
          <h2 className='memories-page__year'>{selectedYear}</h2>
          <p className='memories-page__year-subtitle'>
            {currentYearData?.events.length} evento{currentYearData?.events.length !== 1 ? 's' : ''}
          </p>
          {currentYearData?.summary && (
            <div className='memories-page__year-summary'>
              {currentYearData.summary.map((paragraph) => (
                <p key={paragraph}>{renderFormattedText(paragraph)}</p>
              ))}
            </div>
          )}
        </div>

        <div className='memories-grid'>
          {currentYearData?.events.map((event) => (
            <MemoryItem
              key={event.id}
              type={event.type}
              title={event.title}
              description={event.description}
              date={event.date}
            />
          ))}
        </div>
      </div>

      {/* Newsletter CTA */}
      <NewsletterCTA />
    </section>
  )
}

export default Memories
